import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center font-serif" data-id="element-49">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-50">
          {/* FAQ 1 */}
          <div className={`glass-card rounded-xl overflow-hidden transition-all duration-300 ${openIndex === 0 ? 'border-patriot-red/50 shadow-[0_5px_20px_rgba(178,34,52,0.1)]' : 'border-white/5 hover:border-white/20'}`} data-id="element-51">
            <button onClick={() => toggleFaq(0)} className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none" aria-expanded={openIndex === 0} data-id="element-52">
              <span className={`text-xl font-bold transition-colors ${openIndex === 0 ? 'text-patriot-red' : 'text-white'}`} data-id="element-53">
                Is this based on real events?
              </span>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === 0 ? 'bg-patriot-red/10' : 'bg-white/5'}`} data-id="element-54">
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === 0 ? 'rotate-180 text-patriot-red' : 'text-slate-500'}`} data-id="element-55" />
              </div>
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 0 ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-56">
              <div className="p-6 md:p-8 pt-0 text-slate-400 leading-relaxed text-lg" data-id="element-57">
                It is a work of predictive political fiction based on current
                cultural tensions. A warning of what could happen if we don't
                change course.
              </div>
            </div>
          </div>

          {/* FAQ 2 */}
          <div className={`glass-card rounded-xl overflow-hidden transition-all duration-300 ${openIndex === 1 ? 'border-patriot-red/50 shadow-[0_5px_20px_rgba(178,34,52,0.1)]' : 'border-white/5 hover:border-white/20'}`} data-id="element-58">
            <button onClick={() => toggleFaq(1)} className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none" aria-expanded={openIndex === 1} data-id="element-59">
              <span className={`text-xl font-bold transition-colors ${openIndex === 1 ? 'text-patriot-red' : 'text-white'}`} data-id="element-60">
                Is it suitable for young readers?
              </span>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === 1 ? 'bg-patriot-red/10' : 'bg-white/5'}`} data-id="element-61">
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === 1 ? 'rotate-180 text-patriot-red' : 'text-slate-500'}`} data-id="element-62" />
              </div>
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 1 ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-63">
              <div className="p-6 md:p-8 pt-0 text-slate-400 leading-relaxed text-lg" data-id="element-64">
                Yes, it is vital that the generation who will inherit this
                country understands what's at stake. Recommended for teenagers
                and older who want to understand the current cultural climate.
              </div>
            </div>
          </div>

          {/* FAQ 3 */}
          <div className={`glass-card rounded-xl overflow-hidden transition-all duration-300 ${openIndex === 2 ? 'border-patriot-red/50 shadow-[0_5px_20px_rgba(178,34,52,0.1)]' : 'border-white/5 hover:border-white/20'}`} data-id="element-65">
            <button onClick={() => toggleFaq(2)} className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none" aria-expanded={openIndex === 2} data-id="element-66">
              <span className={`text-xl font-bold transition-colors ${openIndex === 2 ? 'text-patriot-red' : 'text-white'}`} data-id="element-67">
                How do I receive it?
              </span>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === 2 ? 'bg-patriot-red/10' : 'bg-white/5'}`} data-id="element-68">
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === 2 ? 'rotate-180 text-patriot-red' : 'text-slate-500'}`} data-id="element-69" />
              </div>
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 2 ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-70">
              <div className="p-6 md:p-8 pt-0 text-slate-400 leading-relaxed text-lg" data-id="element-71">
                Upon completing your secure payment, the download link will
                appear immediately on screen and a backup copy will also be sent
                to your email instantly.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}